import { createGenerator } from '../sprouts-engine';
import { pack } from '../content/science';

export const generateProblem = createGenerator(pack);
